var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages"},[_c('div',{staticClass:"fanhui",on:{"click":_vm.goback}},[_vm._v("返回")]),_c('div',{attrs:{"id":"container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }